import dayjs from 'dayjs';
import React from 'react';
import { Space } from 'antd';

/**
 * 原生时间输入（开始～结束），避免 TimePicker 浮层选完开始时间就关闭的问题。
 * 与 Form.Item 配合使用，value 为 [dayjs, dayjs]，提交时用 .format('HH:mm:ss')。
 */
const TimeRangeInput = ({ value, onChange }) => {
  const startStr = value?.[0] ? value[0].format('HH:mm') : '14:00';
  const endStr = value?.[1] ? value[1].format('HH:mm') : '15:00';
  const toDayjs = (str) => {
    if (!str) return dayjs().hour(14).minute(0).second(0).millisecond(0);
    const [h, m] = str.split(':').map((x) => parseInt(x, 10) || 0);
    return dayjs().hour(h).minute(m).second(0).millisecond(0);
  };
  return (
    <Space>
      <input
        type="time"
        value={startStr}
        onChange={(e) => onChange([toDayjs(e.target.value), value?.[1] || toDayjs('15:00')])}
        style={{ padding: '4px 8px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}
      />
      <span>至</span>
      <input
        type="time"
        value={endStr}
        onChange={(e) => onChange([value?.[0] || toDayjs('14:00'), toDayjs(e.target.value)])}
        style={{ padding: '4px 8px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}
      />
    </Space>
  );
};

export default TimeRangeInput;
